"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.searchCitiesRequestBody = void 0;
var tslib_1 = require("tslib");
var GraphApi_1 = tslib_1.__importDefault(require("../../../API/GraphApi"));
var __1 = require("..");
var index_1 = require("../../../Config/index");
var newRelic_1 = tslib_1.__importDefault(require("../../newRelic"));
var SEARCH_CITIES_OPNAME = 'searchCities';
var SEARCH_CITIES_QUERY = "query searchCities($input: SearchCityInput!) {\n    searchCities(input: $input) {\n        city\n        state\n        stateAbbreviation\n    }\n  }";
var searchCitiesRequestBody = function (input) { return ({
    operationName: SEARCH_CITIES_OPNAME,
    query: SEARCH_CITIES_QUERY,
    variables: { input: input },
}); };
exports.searchCitiesRequestBody = searchCitiesRequestBody;
var searchCities = function (input) {
    var response = GraphApi_1.default.doOneGraphQuery(searchCitiesRequestBody(input));
    return response
        .then(function (result) { return (0, __1.addressValidationDataTransformer)(result); })
        .catch(function (error) {
        newRelic_1.default.logError({
            errorMessage: 'searchCities failed',
            component: 'CSDK',
            componentVersion: index_1.version,
            originalError: JSON.stringify(error),
        });
        return error;
    });
};
exports.default = searchCities;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/addressValidationApi/oneGraph/searchCities.js
// module id = 3377
// module chunks = 11